module.exports = "<div #baChartistChart class=\"ba-chartist-chart {{baChartistChartClass || ''}}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/baChartistChart/baChartistChart.html
// module id = ../../../../../src/app/theme/components/baChartistChart/baChartistChart.html
// module chunks = 11